import { render } from "./detail-info.vue?vue&type=template&id=4f90fd6c"
import script from "./detail-info.vue?vue&type=script&lang=js"
export * from "./detail-info.vue?vue&type=script&lang=js"

import "./detail-info.vue?vue&type=style&index=0&id=4f90fd6c&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/classic/detail-info.vue'],['render',render],['__file',"detail-info.vue"]])

export default __exports__